import { useMemo } from 'react';

import { AssignmentRequestReasonEnum } from 'api/model';
import useTranslations from 'contexts/basicData/useTranslations';
import { SelectOption } from 'components/inputs/SearchableSelect';

/** De enda anledningar en ny annonsförfrågan kan få. */
const selectableAssignmentRequestReasons: AssignmentRequestReasonEnum[] = [
  AssignmentRequestReasonEnum.StartOfDay,
  AssignmentRequestReasonEnum.EndOfDay,
];

/**
 * @param currentValue En befintlig förfrågan kan ha en äldre anledning (t.ex. "Övrigt"); den
 * visas då också, så att valet inte blir tomt.
 */
const useAssignmentRequestReasonSelectOptions = (
  currentValue?: AssignmentRequestReasonEnum
) => {
  const { assignmentRequestReasons } = useTranslations();

  const options = useMemo(() => {
    const values =
      currentValue === undefined ||
      selectableAssignmentRequestReasons.includes(currentValue)
        ? selectableAssignmentRequestReasons
        : [...selectableAssignmentRequestReasons, currentValue];
    return values.map(
      (value): SelectOption<AssignmentRequestReasonEnum> => ({
        label: String(assignmentRequestReasons[value] ?? '-'),
        value,
      })
    );
  }, [assignmentRequestReasons, currentValue]);
  return options;
};

export default useAssignmentRequestReasonSelectOptions;
